<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-md-11 router-view-background">
    <div class="col-md-12">
      <the-filters
        :filters="computedFilters"
        :showCleareble="showRedefine"
        @get-model="getFiltersModel"
        @on-cleareble="resetService"
        @search="searchItems"
      />
    </div>
    <div v-if="canImportJersey" class="col-md-12 d-flex justify-content-end pb-0 mb-3">
      <v-btn small outlined color="green darken-1" @click="jerseyDialog = true">
        <i class="mdi mdi-cloud-download-outline pr-1" style="font-size:1.1rem"></i>
        Importar da Jersey
      </v-btn>
    </div>
    <v-dialog v-model="jerseyDialog" max-width="420">
      <v-card class="p-3">
        <v-card-title>Importar criador da Associação Jersey</v-card-title>
        <v-text-field v-model="jerseyDoc" label="CPF/CNPJ do criador" outlined dense />
        <v-card-actions class="justify-content-end">
          <v-btn text @click="jerseyDialog = false">Cancelar</v-btn>
          <v-btn color="green darken-1" dark :disabled="!jerseyDoc" @click="importJersey">Importar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="col-md-12">
      <the-table 
        :dataItems="computedList"
        :headers="headersForTable"
      >
        <template v-slot:email="{item}">
          <div>
            <span class="pr-5">{{item.email}}</span>
            <span class="label-creator" title="Rebanho Colaborador" v-tooltip.top="{content:'Rebanho Colaborador'}">RC</span>
          </div>
        </template>
        <template v-slot:actions="{item}">
          <b-dropdown right id="dropdown-menu-table" text="Editar" variant="menu-table" class="m-2 p-0 menu-table">           
            <b-dropdown-item
              class="pr-5 pl-5 b-drop-options"
              variant="text"
              @click="editCriador(item)"
            >
              <i class="mdi mdi-pencil pr-5"></i> Editar Criador
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </the-table>
    </div>
    <button-float 
      icon="mdi mdi-plus"
      @event="openSidebar"
    />
    <sidebar-creators
      :creatorEdit="creatorEdit"
      @close="closeSidebar"
    />
  </div>
</template>

<script>
import TheFilters from "@/components/layout/TheFilters.vue";
import TheTable from "@/components/layout/TheTable.vue";
import ButtonFloat from "@/components/layout/ButtonFloat.vue";
import SidebarCreators from "./SidebarCreators.vue";
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  name:"CreatorsList",
  components: {
    TheTable,
    ButtonFloat,
    SidebarCreators,
    BDropdown,
    BDropdownItem,
    TheFilters
  },
  data() {
    return {
      headersForTable:[
        {text:"Código", value:"code_integration"},
        {text:"Nome", value:"name"},
        {text:"Email", value:"email", has_slot:true},
        {text:"", value:"actions", has_slot:true}
      ],
      creatorEdit:{},
      query:{},
      showRedefine:false,
      jerseyDialog:false,
      jerseyDoc:"",
    }
  },
  computed: {
    ...mapState("creators", ["creators"]),
    ...mapState("login", ["user"]),
    // importação da Jersey (G2): só admin com creators.create, como no back (sem config, o back responde 503)
    canImportJersey() {
      const user = this.user || {};
      return !!user.attributes && user.attributes.kind === "admin" &&
        (user.roles || []).some(r => r.name === "creators.create");
    },
    computedList() {
      return this.creators.map(e => ({
        ...e,
        code_integration:!e.code_integration ? "" : e.code_integration
      }));
    },
    computedFilters() {
      return [
        {name:"code", type:"text", label:"Código"},
        {name:"name", type:"text", label:"Nome"},
        {name:"email", type:"text", label:"Email"},
      ]
    }
  },
  methods: {
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
    ...mapActions("creators", ["actionGetCreators", "actionImportJersey"]),
    async importJersey() {
      try {
        const r = await this.actionImportJersey(this.jerseyDoc);
        this.$toast.success(`Criador ${r.creator === "created" ? "cadastrado" : "já existente"}: ` +
          `${r.farms.created} propriedade(s) nova(s), ${r.animals.created} animal(is) novo(s), ` +
          `${r.animals.updated} completado(s), ${r.animals.ignored.length} ignorado(s).`);
        this.jerseyDialog = false;
        this.jerseyDoc = "";
        await this.actionGetCreators({page:1});
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) this.$toast.error(e.response.data.error);
      }
    },
    openSidebar() {
      this.creatorEdit = {};
      this.SET_ACTIVE(true);
    },
    async closeSidebar() {
      this.SET_ACTIVE(false);
      await this.actionGetCreators({page:1});
      this.creatorEdit = {};
    },
    editCriador(item) {
      this.creatorEdit = item;
      this.SET_ACTIVE(true);
    },
    async resetService() {
      await this.actionGetCreators({page:1});
      this.query = {};
      this.showRedefine = false;
    },
    getFiltersModel(data) {
      this.query[data.title] = data.value
    },
    //Essa função faz o get dos items da tabela conforme os filtros
    async searchItems() {
      const {name, code, email} = this.query;
      if(name || code || email) {
        await this.actionGetCreators(this.query);
        this.showRedefine = true;
      } else {
        this.$toast.warning("Informe ao menos um filtro de pesquisa !");
      }
    },
  },
  async mounted() {
    await this.actionGetCreators({page:1});
  }
}
</script>

<style scoped>
  .label-creator {
    display: inline-block;
    padding: 2px 9px;
    border-radius: 999px;
    font-size: .72rem;
    font-weight: 700;
    letter-spacing: .04em;
    color: #1c7c5c;
    background-color: #e3f7ef;
    cursor: default;
  }
</style>